import { Factory } from 'lucide-react';

const Gallery = () => {
  const galleryImages = [
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/4fyu1679_Gallery1.jpg',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/vdasp4b0_Gallery2.jpg',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/z1w0toqg_Gallery3.png',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/o2e71ncv_Gallery4.png',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/3nnf7bv5_Gallery5.png',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/u1drxo9p_Gallery6.jpg',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/hngiueza_Gallery7.jpg',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/0ut1dnsp_Gallery8.png',
    'https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/gsk00cob_Gallery9.jpg'
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-16 lg:py-24 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_pslcote-labels/artifacts/sxpcdsk5_ChatGPT%20Image%20Nov%2017%2C%202025%2C%2011_36_51%20AM.png" 
            alt="Manufacturing Equipment"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/30"></div>
        </div>
        <div className="section-container relative z-10">
          <h1 className="text-4xl lg:text-5xl font-bold text-white text-center mb-4 drop-shadow-lg" data-testid="gallery-page-title">Gallery</h1>
          <p className="text-lg lg:text-xl text-white text-center mx-auto max-w-3xl drop-shadow-md">
            Explore our state-of-the-art facility, advanced machinery, and diverse product applications
          </p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-16 lg:py-24">
        <div className="section-container">
          <div className="flex items-center justify-center gap-4 mb-12">
            <div className="bg-blue-50 p-3 rounded-lg">
              <Factory className="text-[#0066cc]" size={32} />
            </div>
            <h2 className="text-3xl font-bold pslcote-blue" data-testid="gallery-main-title">
              Manufacturing Facility & Machinery
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {galleryImages.map((image, imgIndex) => (
              <div 
                key={imgIndex} 
                className="relative overflow-hidden rounded-xl shadow-lg group card-hover"
                data-testid={`gallery-image-${imgIndex}`}
              >
                <div className="aspect-[4/3] bg-gray-200">
                  <img
                    src={image}
                    alt={`Manufacturing Facility & Machinery ${imgIndex + 1}`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-4 text-white">
                    <p className="font-semibold">Manufacturing Facility & Machinery</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gallery;